import 'bootstrap'
import '../scss/style.scss'

// Fontawesome

// General
jQuery(document).ready(function ($) {
    let contactBtns = document.querySelectorAll(".nav-link");
    if (contactBtns) {
        let lastBtn = contactBtns[0];
        let rightPages = document.querySelectorAll(".pageHolder-content");
        let lastPage = rightPages[0];
        contactBtns.forEach(btn => {
            btn.addEventListener("click", loadPage)
        });
        let selectBox=document.getElementById("navigation-second");
        selectBox.addEventListener("change", loadPage)
        function loadPage(e, scrollView=true){
            e.preventDefault();
            let item;
            let target= e.currentTarget;
            if(target.id=="navigation-second"){
                item= target.options[target.selectedIndex];
            }else{
                item = target
            }
            if (lastBtn.dataset.href !== item.dataset.href || target.id == "back-up" ) {
                let newPage = document.getElementById(item.dataset.href);
                let indexNew= Array.from(rightPages).indexOf(newPage)
                rightPages.forEach((x, i) => {
                    x.classList.remove("up", "down")
                    if (i> indexNew) {
                        x.classList.add("down")
                    } else if (i < indexNew) {
                        x.classList.add("up")
                    }
                })
                lastPage.classList.remove("active");
                contactBtns.forEach(x=>x.classList.remove("active"))
                item.classList.add("active")
                $(".navigation-second .nav-link[data-href='"+item.dataset.href+"']").addClass("active")
                newPage.classList.add("active");
                if(scrollView){
                    newPage.scrollIntoView()
                }
                
                selectBox.selectedIndex= Array.from(selectBox.options).indexOf(selectBox.querySelector("[data-href='"+item.dataset.href+"']"));
                lastBtn = item;
                lastPage = newPage;
            }
        }
    }
    if ($('.tabbed').length) {
        $('.tabbed__tab').click(function () {
            $('.tabbed__tab').removeClass('active');
            $(this).addClass('active');
            let content= this.closest(".tabbed").querySelector(".tabbed__contents")
            $(content).children('.tabbed__content').removeClass('active');
            $(content).children('.tabbed__content[data-id="' + $(this).data('id') + '"]').addClass('active');
            if(innerWidth<992){
                content.scrollIntoView({block:"center"})
            }
        });
        $('#tab-select').change(function () {
            let index = this.options[this.selectedIndex].dataset.id
            let content= this.closest(".tabbed")
            $(content).children('.tabbed__content').removeClass('active');
            $(content).children('.tabbed__content[data-id="' + index + '"]').addClass('active');
        });
    }
    let tags= document.querySelectorAll(".pageHolder-content")
    let selectBox=document.getElementById("navigation-second");
    document.addEventListener("scroll",()=>{
        var pageTop = $(document).scrollTop()
        var pageBottom = pageTop + $(window).height()
        
        for (var i = 0; i < tags.length; i++) {
            var tag = tags[i]
            
            if ($(tag).offset().top < pageBottom - (window.innerHeight/2)) {
                if( ! ($(tag).offset().top+ tag.clientHeight) > pageTop){ 
                    return;
                }
                setBackground(i);
                $(".navigation-second .nav-link:not([data-href='"+tag.id+"'])").removeClass("active")
                $(".navigation-second .nav-link[data-href='"+tag.id+"']").addClass("active")
                selectBox.selectedIndex= Array.from(selectBox.options).indexOf(selectBox.querySelector("[data-href='"+tag.id+"']"));
            }else{
                removeBackground(i);
            }
        }
    })
    let modal = document.getElementById("modal");
    let modalBody = modal.querySelector(".modal-body");
    document.querySelectorAll("[data-bs-toggle='modal']").forEach(x=>{
        x.addEventListener("click",e=>{
            modalBody.innerHTML=`<h4>${x.dataset.titel}</h4>`+x.dataset.text;
            $(modal).modal('show')
        })
    })

    function setBackground(index){
        let pageholder= document.querySelector(".pageHolder")
        pageholder.classList.add("page"+index);
    }
    function removeBackground(index){
        let pageholder= document.querySelector(".pageHolder")
        pageholder.classList.remove("page"+index);
    }
    
    let Slidetags = $('.slideIn')
    $(document).on('scroll', onScrollAnimate)
    function onScrollAnimate() {
        var pageTop = $(document).scrollTop()
        let screenHeight= $(window).height();
        var pageBottom = pageTop + screenHeight
        for (var i = 0; i < Slidetags.length; i++) {
            var tag = Slidetags[i]

            if ($(tag).offset().top < pageBottom - (screenHeight*0.05)) {
                tag.classList.add('visible')
                tag.ontransitionend = (e)=>{
                    if(tag.classList.contains("visible")){
                        tag.classList.remove("visible","slideIn")
                    }
                };
                Slidetags.splice(i, 1);
            }else {
                tag.classList.remove('visible')
            }
        }
       
    }
    setTimeout(()=>{
        for(var i=0;i<10;i++){
            onScrollAnimate()
        }
    },250)
    
    window.addEventListener("resize",fixBg)
    fixBg()
    function fixBg(){
        if(window.innerWidth<1200){
            let test= document.querySelector(".navigation-first-item:nth-child(4) object")
            test.addEventListener("load",e=>{
                test.getSVGDocument().getElementById("Path_2603").style.fill="#dad56f";
            })
        }
    }
    
});


